export const OFFER_DETAILS_OVERLAY_SECTION_OFFER_DETAILS =
  'offer-details-overlay-section-offer-details' as const;
export const OFFER_DETAILS_OVERLAY_SECTION_FLIGHT_DETAILS =
  'offer-details-overlay-section-flight-details' as const;
export const OFFER_DETAILS_OVERLAY_SECTION_TOUR_OPERATOR_IMAGES =
  'offer-details-overlay-section-tour-operator-images' as const;
export const OFFER_DETAILS_OVERLAY_SECTION_CONTACT =
  'offer-details-overlay-section-contact' as const;

export type OfferDetailsOverlaySection =
  | typeof OFFER_DETAILS_OVERLAY_SECTION_OFFER_DETAILS
  | typeof OFFER_DETAILS_OVERLAY_SECTION_FLIGHT_DETAILS
  | typeof OFFER_DETAILS_OVERLAY_SECTION_TOUR_OPERATOR_IMAGES
  | typeof OFFER_DETAILS_OVERLAY_SECTION_CONTACT;
